<template lang="pug">
  //- 修改班级人数
  el-dialog(title="修改班级人数" :visible.sync="updateClassCount_dialogVisible" width="30%" :modal-append-to-body="false" :close-on-click-modal="false" @close="updateClassCount_cancelClose")
    div(style="margin-bottom: 20px;") 当前班级人数：
      span(style="font-size: 18px; font-weight: bold; color: red;") {{ updateClassCount_static.joinCount }} / {{ updateClassCount_static.classCount }}
    el-form(ref="updateClassCount_ref" :model="updateClassCount_form" :rules="updateClassCount_rules" label-width="auto")
      el-form-item(label="班级人数：" prop="classCount")
        el-input(v-model="updateClassCount_form.classCount" placeholder="请输入班级人数")
    span.dialog-footer(slot="footer")
      el-button(type="primary" @click="updateClassCount_submit") 确 定
      el-button(@click="updateClassCount_dialogVisible = false") 取 消
</template>

<script>
export default {
  name: 'UpdateClassCount',
  data () {
    return {
      updateClassCount_dialogVisible: false,
      updateClassCount_form: { // 提交表单
        trainId: null,
        classCount: null
      },
      updateClassCount_static: { // 静态数据
        classCount: null,
        joinCount: null
      },
      updateClassCount_rules: {
        classCount: [{
          required: true,
          message: '班级人数不能为空！',
          trigger: 'blur'
        }, {
          validator: (rule, value, callback) => {
            if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error('班级人数必须是大于零的整数！'))
            } else if (value < this.updateClassCount_static.joinCount) {
              callback(new Error('班级人数不得小于签位人数！'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    // 初始化
    init (trainId, classCount, joinCount) {
      this.updateClassCount_dialogVisible = true
      this.updateClassCount_form.trainId = trainId
      this.updateClassCount_form.classCount = classCount
      this.updateClassCount_static.classCount = classCount
      this.updateClassCount_static.joinCount = joinCount
    },
    // 修改班级人数-提交
    updateClassCount_submit () {
			this.$refs['updateClassCount_ref'].validate(valid => {
				if (valid) {
          this.$http({
            url: this.$http.adornUrl('/pxTrain/updateClassCount'),
            method: 'GET',
            params: this.updateClassCount_form
          }).then(data => {
            if (data && data.code === 0) {
              this.$message.success('修改成功')
              this.updateClassCount_dialogVisible = false
              this.$emit('confirm')
            } else {
              this.$message.error(data.msg || '修改失败，请重试！')
            }
          })
				}
			})
    },
    // 修改班级人数-关闭
    updateClassCount_cancelClose () {
      this.$refs['updateClassCount_ref'].clearValidate()
    }
  }
}
</script>
